import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { all_routes } from "../../../../router/all_routes";
import Cookies from "js-cookie";
import { useUserPermissions } from "../../../../UserPermissionsContext";
import DualListBox from "../../../../duallistBox";
import { Toast } from "react-bootstrap";

interface Option {
  value: number;
  label: string;
}
type DualList = { id: number; name: string };

interface ErrorMessages {
  name?: string[];
  is_active?: string[];
}

const EditTeamManagers = () => {
  const routes = all_routes;
  const navigate = useNavigate();
  const location = useLocation();
  const { id } = location.state || {};
  const jwtToken = Cookies.get("authToken");
  const { userPermissions, webApi } = useUserPermissions();
  const [isLoading, setIsLoading] = useState(false);
  const [isActive, setIsActive] = useState(true);
  const [managerName, setManagerName] = useState<string>("");
  const [teamManagers, setTeamManagers] = useState<DualList[]>([]);
  const [chosenTeamManagers, setChosenTeamManagers] = useState<DualList[]>([]);
  const [showSolidDangerToast, setShowSolidDangerToast] = useState(false);
  const [showSolidSuccessToast, setshowSolidSuccessToast] = useState(false);
  const handleSolidSuccessToastClose = () => setshowSolidSuccessToast(false);
  const handleSolidDangerToastClose = () => setShowSolidDangerToast(false);
  const [errorMessage, setErrorMessage] = useState<ErrorMessages>({});
  const [toastMessage, setToastMessage] = useState("");
  useEffect(() => {
    if ((showSolidDangerToast || showSolidSuccessToast) === true) {
      setTimeout(() => setShowSolidDangerToast(false), 5000);
      setTimeout(() => setshowSolidSuccessToast(false), 5000);
    }
  }, [toastMessage]);
  const checkPermission = (action: any, subject: any) => {
    return userPermissions.some(
      (ability) => ability.action === action && ability.subject === subject,
    );
  };

  const options = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${jwtToken}`,
    },
  };

  const fetchTeamMembers = async () => {
    const response = await fetch(
      `${webApi}/sed/users_dropdown_for_sed_team_managers/`,
      options,
    );

    const data = await response.json();

    const mapped = data.map((item: any) => ({
      id: item.id,
      name: item.name,
    }));

    setTeamManagers(mapped);
    return mapped; // important
  };

  const fetchSEDManager = async (allManagers: DualList[]) => {
    const response = await fetch(
      `${webApi}/sed/sed_team_managers/${id}/`,
      options,
    );

    const data = await response.json();

    setManagerName(data.name);
    setIsActive(data.is_active);

    const selectedManagers = allManagers.filter((manager) =>
      data.managers.includes(manager.id),
    );

    setChosenTeamManagers(selectedManagers);
  };

  useEffect(() => {
    const loadData = async () => {
      if (!checkPermission("change_sedmanagers", "sedmanagers")) {
        navigate(routes.crmLandingPage);
        return;
      }
      const allManagers = await fetchTeamMembers();
      await fetchSEDManager(allManagers);
    };

    loadData();
  }, [userPermissions]);

  const handleSubmit = async (e: any) => {
    e.preventDefault();
    const finalData = {
      name: managerName,
      managers: chosenTeamManagers.map((manager) => manager.id),
      is_active: isActive,
    };

    try {
      setIsLoading(true);
      const response = await fetch(`${webApi}sed/sed_team_managers/${id}/`, {
        method: "PUT",
        headers: {
          Authorization: `Bearer ${jwtToken}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(finalData),
      });
      if (!response.ok) {
        const errorData = await response.json();
        setErrorMessage(errorData);
        setToastMessage(errorData.name);
        if (toastMessage !== "") {
          setShowSolidDangerToast(true);
        }
        throw new Error("Network response was not ok");
      }
      navigate(routes.SEDTeamMangers);
    } catch (error) {
    } finally {
      setIsLoading(false);
    }
  };

  const handleTeamManagerChange = (selected: DualList[]) => {
    setChosenTeamManagers(selected);
  };

  return (
    <div>
      <div className="page-wrapper">
        <div className="content container-fluid">
          {/* Page Header */}
          <div className="page-header">
            <div className="row">
              <div className="col-sm-12">
                <h3 className="page-title">Edit Manager</h3>
                <ul className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to={routes.SEDDashBoard}>Dashboard</Link>
                  </li>
                  <li className="breadcrumb-item">
                    <Link to={routes.SEDTeamMangers}>Team Managers</Link>
                  </li>
                  <li className="breadcrumb-item active">Edit</li>
                </ul>
              </div>
            </div>
          </div>
          {/* /Page Header */}

          {/* Row */}
          <div className="row justify-content-center">
            <div className="col-sm-12 d-flex justify-content-center">
              {/* Add manager */}
              <div
                className="card w-100"
                style={{
                  maxWidth: "900px",
                  boxShadow: "0 4px 8px rgba(0,0,0,0.2)",
                  borderRadius: "10px",
                }}
              >
                <div className="card-body">
                  <form onSubmit={handleSubmit}>
                    <div className="row g-3 mb-3">
                      <div className="col-12 col-md-6">
                        <label className="form-label">Team Name</label>
                        <input
                          type="text"
                          className={`form-control ${
                            errorMessage.name ? "is-invalid" : ""
                          }`}
                          name="name"
                          placeholder="Team Name"
                          onChange={(e) => {
                            setManagerName(e.target.value);
                          }}
                          value={managerName}
                          required
                        />
                        {errorMessage.name && (
                          <div className="invalid-feedback">
                            {errorMessage.name[0]}
                          </div>
                        )}
                      </div>
                      <div className="col-md-6">
                        <div className="radio-group mb-3">
                          <label className="form-label">
                            Is Active 
                          </label>

                          <div className="d-flex gap-4 mt-2">
                            <div className="form-check">
                              <input
                                className="form-check-input"
                                type="radio"
                                name="isActive"
                                id="activeYes"
                                checked={isActive === true}
                                onChange={() => setIsActive(true)}
                              />
                              <label
                                className="form-check-label"
                                htmlFor="activeYes"
                              >
                                Active
                              </label>
                            </div>

                            <div className="form-check">
                              <input
                                className="form-check-input"
                                type="radio"
                                name="isActive"
                                id="activeNo"
                                checked={isActive === false}
                                onChange={() => setIsActive(false)}
                              />
                              <label
                                className="form-check-label"
                                htmlFor="activeNo"
                              >
                                Inactive
                              </label>
                            </div>
                          </div>
                          {errorMessage.is_active && (
                            <div className="text-danger mt-1">
                              {errorMessage.is_active[0]}
                            </div>
                          )}
                        </div>
                      </div>
                      {/* <div style={{ width: "28%" }}>
                        <label className="form-label">Team Type</label>
                        <Select
                          value={selectedTeamType}
                          onChange={handleTeamTypeChange}
                          options={teamTypeOptions}
                          placeholder="Select a team Type"
                          required
                        />
                      </div> */}
                    </div>

                    <div className="form-group dual-list-box-container">
                      <label className="form-label">Managers</label>
                      <DualListBox
                        options={teamManagers}
                        selected={chosenTeamManagers}
                        onChange={handleTeamManagerChange}
                      />
                    </div>
                    {/* <div className="form-group dual-list-box-container">
                      <label className="form-label">Team Members</label>
                      <DualListBox
                        options={teamMembers}
                        selected={chosenTeamMembers}
                        onChange={handleTeamMembersChange}
                      />
                    </div> */}
                    <div className="modal-footer">
                      <Link
                        className="btn btn-primary"
                        type="submit"
                        to={routes.SEDTeamMangers}
                        style={{
                          backgroundColor: "lightcoral",
                          color: "white",
                          marginRight: "5px",
                        }}
                      >
                        Cancel
                      </Link>
                      <button
                        className="btn btn-primary"
                        type="submit"
                        disabled={isLoading}
                      >
                        {isLoading ? (
                          <i className="spinner-border spinner-border-sm"></i>
                        ) : (
                          <>Save</>
                        )}
                      </button>
                    </div>
                  </form>
                </div>
              </div>
              {/* /Add Group */}
            </div>
          </div>
          {/* /Row */}
          <Toast
            show={showSolidDangerToast}
            onClose={handleSolidDangerToastClose}
            id="solidDangerToast"
            className="colored-toast bg-danger text-fixed-white"
            role="alert"
            aria-live="assertive"
            aria-atomic="true"
            style={{
              position: "fixed",
              top: "20px",
              right: "20px",
              zIndex: 1050,
            }}
          >
            <Toast.Body>{toastMessage}</Toast.Body>
          </Toast>
          <Toast
            show={showSolidSuccessToast}
            onClose={handleSolidSuccessToastClose}
            id="solidSuccessToast"
            className="colored-toast bg-success text-fixed-white"
            role="alert"
            aria-live="assertive"
            aria-atomic="true"
            style={{
              position: "fixed",
              top: "20px",
              right: "20px",
              zIndex: 1050,
            }}
          >
            <Toast.Body>{toastMessage}</Toast.Body>
          </Toast>
        </div>
      </div>
    </div>
  );
};

export default EditTeamManagers;
